module.exports = __webpack_public_path__ + "img/28-5.214b3e73.jpg";